import { render, staticRenderFns } from "./shared-paper-list.html?vue&type=template&id=c20f70bc&scoped=true&external"
import script from "./shared-paper-list.js?vue&type=script&lang=js&external"
export * from "./shared-paper-list.js?vue&type=script&lang=js&external"
import style0 from "./shared-paper-list.scss?vue&type=style&index=0&id=c20f70bc&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c20f70bc",
  null
  
)

export default component.exports